const login = {
  subtitleTop: 'Injection Molding Monitoring System',
  systemTitle: 'Injection Molding Control System',
  adminLogin: 'Administrator Login',
  email: 'Email',
  password: 'Password',
  rememberMe: 'Remember me',
  submit: 'Sign In',
  submitting: 'Signing in...',
  forgotPassword: 'Forgot password?',
  forgotPasswordAlert: 'Please contact the administrator to recover your password.\n\nAdmin email: skm@seoro.ai.kr',
  contactAdminAlert: 'Please contact the administrator to create an account.\n\nAdmin email: skm@seoro.ai.kr',
  noAccount: "Don't have an account?",
  contactAdmin: 'Contact administrator',
  loginFailed: 'Login failed',
  serverError: 'Unable to connect to the server',
};

export default login;
